import { Flex } from '@banhala/ui-kit';
import { isNil, withWebviewOrigin } from 'shared/src/utils';
import { useWebViewActionFromMessage } from 'shared/src/hooks';
import React, { useMemo } from 'react';
import { WebView } from 'shared/src/component/WebWebView';
import { EMBEDDED_WEB_QUERY_KEY } from 'shared/src/constants/webviewQuery';

export const HomeWebView: React.FC<{
  url?: string;
}> = ({ url }) => {
  const webViewAction = useWebViewActionFromMessage();
  // const url = useMemo(() => {
  //   if (isNil(props.url)) return undefined;
  //   const parsed = new URL(props.url);
  //   parsed.searchParams.set('global_layout', 'app');
  //   return parsed.toString();
  // }, [props.url]);

  const uri = useMemo(() => {
    if (isNil(url)) return undefined;
    // return new URL(url).toString();

    const urlObj = new URL(url);

    urlObj.searchParams.set('bottom-tab', 'true');
    urlObj.searchParams.set('global_layout', 'app');
    // iframe 임베드임을 콘텐츠에 명시한다(.web 전용 구현이라 항상 임베드).
    urlObj.searchParams.set(EMBEDDED_WEB_QUERY_KEY, 'true');

    // 접속한 호스트에 맞는 콘텐츠 origin 으로 교체(path/query 는 서버 응답 그대로 유지).
    // prod → m.a-bly.com / stag-N.mobile → m-stag-N.a-bly.com / 그 외 → 로컬 :3000
    return withWebviewOrigin(urlObj);
  }, [url]);

  if (isNil(uri)) return null;

  return (
    <Flex flex={1}>
      <WebView style={{ flex: 1 }} source={{ uri }} onMessage={webViewAction} />
    </Flex>
  );
};
